import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

// Import images - in React.js, you need to import images directly
import hero1 from '../assets/img/Website media/Chia Seeds/ChiaHero.jpg';
import hero2 from '../assets/img/Website media/Flax Seeds/Flx6.jpeg';
import hero3 from '../assets/img/Website media/Quinoa/QuinoaHero.jpg';
import hero4 from '../assets/img/Website media/Moringa/MoringaHero.jpg';
import hero5 from '../assets/img/Website media/Avocado/Avo2.jpeg';

const HeroSection = () => {
  const carouselItems = [
    {
      image: hero1,
      title: "Empowering Farmers, Connecting Markets",
      description: "Zao Afrika empowers farmers to produce high quality organic food for both local and export markets."
    },
    {
      image: hero2,
      title: "You Plant, We Handle the Rest",
      description: "Let us handle your input financing, risk management, value addition and marketing, so you can focus on farming."
    },
    {
      image: hero3,
      title: "Earn More, Stress Less",
      description: "At Zao Afrika, we are committed to maximizing farmers' profits while reducing the burden of production."
    },
    {
      image: hero4,
      title: "A Partnership for Success",
      description: "We work with farmers to turn raw harvests into high-value products that fetch high prices in the market."
    },
    {
      image: hero5,
      title: "Your Farm. Your Growth. Your Future.",
      description: "Stay ahead with real-time market insights, digital tools, and expert training to help you scale your agri-business."
    }
  ];

  useEffect(() => {
    // Initialize Bootstrap carousel
    const bootstrap = require('bootstrap/dist/js/bootstrap.bundle.min.js');
    new bootstrap.Carousel(document.getElementById('hero-carousel'), {
      interval: 5000
    });
  }, []);

  return (
    <section id="hero" className="hero section dark-background p-0 m-0">
      <div 
        id="hero-carousel" 
        className="carousel slide carousel-fade" 
        data-bs-ride="carousel"
      >
        <div className="carousel-indicators">
          {carouselItems.map((_, index) => (
            <button
              key={index}
              type="button"
              data-bs-target="#hero-carousel"
              data-bs-slide-to={index}
              className={index === 0 ? "active" : ""}
              aria-current={index === 0 ? "true" : "false"}
              aria-label={`Slide ${index + 1}`}
            />
          ))}
        </div>

        <div className="carousel-inner">
          {carouselItems.map((item, index) => (
            <div key={index} className={`carousel-item ${index === 0 ? 'active' : ''}`}>
              <img 
                src={item.image} 
                alt={item.title}
                className="d-block w-100 h-100"
                style={{ objectFit: 'cover' }}
              />
              <div className="carousel-container">
                <h2>{item.title}</h2>
                <p>{item.description}</p>
              </div>
            </div>
          ))}
        </div>

        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#hero-carousel"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>

        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#hero-carousel"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>

      <style>
        {`
          .hero {
            width: 100%;
            min-height: 100vh;
            position: relative;
            padding: 0 !important;
            margin: 0 !important;
          }

          .hero .carousel {
            width: 100%;
            min-height: 100vh;
            position: relative;
          }

          .hero .carousel-item {
            position: relative;
            height: 100vh;
          }

          .hero .carousel-container {
            position: absolute;
            bottom: 0;
            top: 0;
            left: 0;
            right: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            text-align: center;
            padding: 0 15px;
            background: rgba(0, 0, 0, 0.5);
          }

          .hero .carousel-container h2 {
            color: #fff;
            font-size: 48px;
            font-weight: 700;
            margin-bottom: 16px;
          }

          .hero .carousel-container p {
            color: #fff;
            font-size: 18px;
            margin-bottom: 0;
          }

          @media (max-width: 768px) {
            .hero .carousel-container h2 {
              font-size: 32px;
            }
          }
        `}
      </style>
    </section>
  );
};

export default HeroSection;